import styled from "@emotion/styled"
import { wv_willfade } from "./../styles"
import getMediaQuery, { media } from "css/breakpoints"

export const Main = styled.nav`
  display: none;
  position: relative;
  z-index: 1;
  padding: 10px var(--outer-margin);
  box-sizing: border-box;
  justify-content: center;
  position: relative;
  width: 100%;
  bottom: 0;
  left: 0;
  pointer-events: none;
  align-items: center;
  transform: translateZ(0);
  transition: background 0s linear 0.6s;
  background: transparent;

  ${getMediaQuery("m")} {
    .wv_ref & {
      display: none !important;
    }
  }

  &::before {
    content: "";
    width: 20px;
    transform: translateX(-100%);
    [dir="rtl"] & {
      transform: translateX(100%);
    }
  }

  > svg {
    ${wv_willfade}
    &.wv_reveal {
      transition-delay: 600ms;
    }
    fill: var(--light-black);
    transform: translateX(100%);
    [dir="rtl"] & {
      transform: translateX(-100%);
    }
  }

  &.wv_reveal {
    display: flex;
  }

  &.wv_sticky {
    transition-duration: 0.3s;
    position: sticky;
    background: rgb(var(--pure-white));
  }

  &.wv_ready {
    transition-delay: 0s;
  }
`
